import React, { FC, useState } from "react";
import { DEMO_HOTEL_LISTINGS, DEMO_STAY_LISTINGS } from "data/listings";
import { Helmet } from "react-helmet";
import NcImage from "shared/NcImage/NcImage";
import Input from "shared/Input/Input";
import ButtonCircle from "shared/Button/ButtonCircle";
import Nav from "shared/Nav/Nav";
import NavItem from "shared/NavItem/NavItem";
import Pagination from "shared/Pagination/Pagination";
import PropertyCardH from "components/PropertyCardH/PropertyCardH";
import { useParams } from "react-router-dom";
import { HotelDataType, HotelType, StayDataType } from "data/types";
import StayCard from "components/StayCard/StayCard";
import { DEMO_HOTELS } from "data/hotels";

export interface PageSearchProps {
  className?: string;
}

const hotels: HotelType[] = DEMO_HOTELS.filter((_, i) => i < 8)
const apartment: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i < 8)

const TABS = ["Hotels", "Apartments"];

interface RouteParams {
  query: string
}

const PageSearch: FC<PageSearchProps> = ({ className = "" }) => {


  let { query } = useParams<RouteParams>();

  const [tabActive, setTabActive] = useState<typeof TABS[number]>(TABS[0]);

  const handleClickTab = (item: string) => {
    if (item === tabActive) {
      return;
    }
    setTabActive(item);
  };

  const [data,setData] = useState(hotels)

  //Pagination
 const dataLimit = 8;
 const [pages] = React.useState(Math.round(data.length / dataLimit));
 const [currentPage, setCurrentPage] = React.useState(1);

 function changePage(event: React.MouseEvent<HTMLButtonElement>) {
  const pageNumber = Number(event.currentTarget.textContent);
  setCurrentPage(pageNumber);
}

  const getPaginatedData = () => {
    const startIndex = currentPage * 8 - dataLimit;
    const endIndex = startIndex + dataLimit;
    return data.slice(startIndex, endIndex);
  };


  return (
    <div className={`nc-PageSearch ${className}`} data-nc-id="PageSearch">
      <Helmet>
        <title>Nilebooking || Search Page</title>
      </Helmet>

      {/* HEADER */}
      <div className="w-screen px-2 xl:max-w-screen-2xl mx-auto">
        <div className="rounded-3xl relative aspect-w-16 aspect-h-16 sm:aspect-h-9 lg:aspect-h-5 overflow-hidden ">
          <NcImage
            containerClassName="absolute inset-0"
            src="https://images.pexels.com/photos/2138922/pexels-photo-2138922.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
            className="object-cover w-full h-full"
          />
        </div>
        {/* CONTENT */}
        <div className="relative container -mt-20 lg:-mt-48">
          <div className=" bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 p-5 lg:p-16 rounded-[40px] shadow-2xl flex items-center">
            <header className="w-full max-w-3xl mx-auto text-center flex flex-col items-center">
              <h2 className="text-2xl sm:text-4xl font-semibold">{query}</h2>
              <span className="block text-xs sm:text-sm mt-4 text-neutral-500 dark:text-neutral-300">
                We found{" "}
                <strong className="font-medium text-neutral-800 dark:text-neutral-100">
                  1135
                </strong>{" "}
                results for{" "}
                <strong className="font-medium text-neutral-800 dark:text-neutral-100">
                  {query}
                </strong>
              </span>
              <form
                className="relative w-full mt-8 sm:mt-11 text-left"
                method="post"
              >
                <label
                  htmlFor="search-input"
                  className="text-neutral-500 dark:text-neutral-300"
                >
                  <span className="sr-only">Search all icons</span>
                  <Input
                    id="search-input"
                    type="search"
                    placeholder="Type and press enter"
                    sizeClass="pl-14 py-5 pr-5 md:pl-16"
                    defaultValue={query}
                  />
                  <ButtonCircle
                    className="absolute right-2.5 top-1/2 transform -translate-y-1/2"
                    size=" w-11 h-11"
                    type="submit"
                  >
                    <i className="las la-arrow-right text-xl"></i>
                  </ButtonCircle>
                  <span className="absolute left-5 top-1/2 transform -translate-y-1/2 text-2xl md:left-6">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M19.25 19.25L15.5 15.5M4.75 11C4.75 7.54822 7.54822 4.75 11 4.75C14.4518 4.75 17.25 7.54822 17.25 11C17.25 14.4518 14.4518 17.25 11 17.25C7.54822 17.25 4.75 14.4518 4.75 11Z"
                      ></path>
                    </svg>
                  </span>
                </label>
              </form>
            </header>
          </div>
        </div>
      </div>
      {/* ====================== END HEADER ====================== */}

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <main>
          {/* TABS FILTER */}
          <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <Nav
              containerClassName="w-full overflow-x-auto hiddenScrollbar"
              className="sm:space-x-2"
            >
              {TABS.map((item, index) => (
                <NavItem
                  key={index}
                  isActive={tabActive === item}
                  onClick={() => handleClickTab(item)}
                >
                  {item}
                </NavItem>
              ))}
            </Nav>
            <div className="block my-4 border-b w-full border-neutral-100 sm:hidden"></div>
          </div>

          {/* LOOP ITEMS */}
          {/* LOOP ITEMS POSTS */}
          {tabActive === "Hotels" && (
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-8 mt-8 lg:mt-10">
              {hotels.map((post) => (
                <StayCard key={post.id} data={post}/>
              ))}
            </div>
          )}
          {/* LOOP ITEMS CATEGORIES */}
          {tabActive === "Apartments" && (
            <div className="grid grid-cols-1 gap-6 md:gap-8 xl:grid-cols-2">
              {apartment.map((stay) => (
                <PropertyCardH key={stay.id} data={stay} />
              ))}
            </div>
          )}

          {/* PAGINATION */}
          <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
            <Pagination
                pages={pages}
                currentPage={currentPage}
                changePage={changePage}
            />
          </div>
        </main>

        {/* MORE SECTIONS */}
        {/* === SECTION 5 === */}
      </div>
    </div>
  );
};

export default PageSearch;
